import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useLocation } from 'react-router-dom';
import { isAppleSurfacePath } from '../views/appleTvHost';
import useCurrentCuratorProfilePath from '../views/useCurrentCuratorProfilePath';
import './style.css';
import './style2.css';

const NavBar = () => {
  const { isAuthenticated, loginWithRedirect, user } = useAuth0();
  const location = useLocation();
  const isAppleSurface = isAppleSurfacePath(location.pathname);
  const isMailSurface = location.pathname.startsWith('/mail');
  const isTeaSurface = location.pathname === '/tea' || location.pathname === '/apple/tea';
  const profilePath = useCurrentCuratorProfilePath({ isAuthenticated, user, fallbackPath: '/profile' });

  const isActive = (pathPrefix) => location.pathname === pathPrefix || location.pathname.startsWith(`${pathPrefix}/`);

  if (isAppleSurface || isMailSurface || isTeaSurface) {
    return null;
  }

  return (
    <header className="curator-nav" role="banner">
      <div className="curator-nav__inner">
        <Link to="/" className="curator-nav__brand">
          Curator
        </Link>

        <nav className="curator-nav__center" aria-label="Primary">
          <Link to="/" className={`curator-nav__link ${isActive('/') || isActive('/explore') ? 'is-active' : ''}`}>
            Watchlist
          </Link>
          <a href="/guide/live-guide/index.html" className="curator-nav__link">
            Print
          </a>
          <Link to="/mail" className={`curator-nav__link ${isActive('/mail') ? 'is-active' : ''}`}>
            Mail
          </Link>
          <Link to="/developer/api" className={`curator-nav__link ${isActive('/developer/api') ? 'is-active' : ''}`}>
            API
          </Link>
          <Link to="/apple" className={`curator-nav__link ${isActive('/apple') ? 'is-active' : ''}`}>
            TV+
          </Link>
        </nav>

        <div className="curator-nav__right">
          <Link to="/search" className={`curator-nav__link ${isActive('/search') ? 'is-active' : ''}`}>
            Search
          </Link>
          {isAuthenticated ? (
            <Link to={profilePath} className={`curator-nav__link ${isActive('/profile') || location.pathname === profilePath ? 'is-active' : ''}`}>
              Account
            </Link>
          ) : (
            <button type="button" className="curator-nav__link curator-nav__button" onClick={() => loginWithRedirect()}>
              Account
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default NavBar;
